export function DashboardPreviewSection({ theme, t, logoUrl, appName }) {
  return (
    <section key="dashboard_preview" data-section="dashboard_preview" className="pb-12 px-4 sm:px-6 lg:px-8 -mt-4">
      <div className="max-w-5xl mx-auto">
        <div className={`${theme === 'dark' ? 'bg-gradient-to-b from-gray-800 to-gray-900' : 'bg-white'} rounded-2xl ${t.borderSecondary} border shadow-2xl overflow-hidden`}>
          <div className={`${t.windowBar} px-4 py-3 flex items-center gap-2 ${t.borderSecondary} border-b`}>
            <div className="w-3 h-3 rounded-full bg-red-500" />
            <div className="w-3 h-3 rounded-full bg-yellow-500" />
            <div className="w-3 h-3 rounded-full bg-green-500" />
          </div>
          <div className={`p-8 min-h-[300px] flex items-center justify-center ${theme === 'light' ? 'bg-gray-50' : ''}`}>
            <div className="text-center">
              <img src={logoUrl} alt={appName} className="w-24 h-24 mx-auto mb-4 object-contain" loading="lazy" decoding="async" />
              <p className={t.textSecondary}>Your team dashboard awaits</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
